import _toNumber from 'lodash/toNumber'
import _isNumber from 'lodash/isNumber'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import PackageJson from '../../../package.json'

const {
  REACT_APP_SENTRY_ENV: environment,
  REACT_APP_SENTRY_DSN: dsn,
  REACT_APP_SENTRY_DEBUG: debug,
  REACT_APP_SENTRY_ENABLED: enabled,
  REACT_APP_SENTRY_TRACES_SAMPLE_RATE: tracesSampleRate,
} = process.env

Sentry.init({
  dsn,
  environment,
  debug: debug === 'true',
  enabled: enabled === 'true',
  release: `next-gen-web@${PackageJson.version}`,
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: [/^\//],
    }),
  ],
  // We recommend adjusting this value in production, or using tracesSampler for finer control
  tracesSampleRate: _isNumber(tracesSampleRate) ? _toNumber(tracesSampleRate) : 1.0,
})

function SentryContainer({ children }: { children?: JSX.Element }): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      showDialog={environment === 'production'}
      fallback={({ error, componentStack, resetError }) => (
        <>
          <div>You have encountered an error</div>
          <div>{error.toString()}</div>
          <div>{componentStack}</div>
          <button
            type="button"
            onClick={() => {
              resetError()
            }}
          >
            Click here to reset!
          </button>
        </>
      )}
    >
      {children ? children : null}
    </Sentry.ErrorBoundary>
  )
}

export default SentryContainer

// https://sentryv21.leadliaison.com/api/4/envelope/?sentry_key=df00e14c621a49899cd0173a6296b1d5&sentry_version=7
// https://sentryv21.leadliaison.com/api/4/envelope/?sentry_key=df00e14c621a49899cd0173a6296b1d5&sentry_version=7
